@use "../Clickables/index.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;

[data-design-version="v2024"] .richText {
    :where(h1, h2, h3) {
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(h1, h2) {
        font: var(--font-h-34);
    }

    :where(h3) {
        font: var(--font-h-24);
    }

    :where(h4, h5, h6) {
        font: var(--font-h-24);
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(p, li) {
        margin-block: var(--spacer-16);
        font: var(--font-p-16);
        color: var(--color-text-secondary);

        i {
            font-style: italic;
        }
    }

    :where(ul, ol) {
        margin-block: var(--spacer-16);
        padding-left: 1.5em;

        ::marker {
            width: 1em;
        }
    }

    li {
        padding-left: 0.3em;
    }

    a {
        color: inherit;
        text-underline-offset: 0.1875em;

        &:focus-visible {
            border-radius: 4px;
            outline: var(--outline);
            outline-offset: 1px;
        }
    }

    :global(.eyebrow) {
        font: var(--font-eyebrow);
        margin-bottom: var(--spacer-24);
        letter-spacing: 0.1em;
        text-transform: uppercase;
        text-decoration: underline;
        text-decoration-color: var(--red);
        text-underline-offset: 0.33em;

        @media ($above-mobile) and ($below-tablet) {
            margin-bottom: var(--spacer-16);
        }
    }

    a:global(.buttonFilled) {
        @include filled-button-2024;

        margin-top: var(--spacer-16);
    }

    a:global(.secondaryButton) {
        @include secondary-button-2024;
    }

    img {
        display: inline;
    }
}

[data-design-version="v2026"] .richText {
    :where(h1, h2, h3) {
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(h1, h2) {
        font: var(--font-h-40);
    }

    :where(h3) {
        font: var(--font-h-32);
    }

    :where(h4, h5, h6) {
        font: var(--font-h-24);
        margin-block: var(--spacer-24) var(--spacer-16);
    }

    :where(p, li) {
        margin-block: var(--spacer-16);
        font: var(--font-p-16);
        color: var(--color-text-secondary);

        i {
            font-style: italic;
        }
    }

    :where(ul, ol) {
        margin-block: var(--spacer-16);
        padding-left: 1.5em;

        ::marker {
            width: 1em;
        }
    }

    li {
        padding-left: 0.3em;
    }

    a {
        color: inherit;
        text-underline-offset: 0.1875em;

        &:focus-visible {
            border-radius: 4px;
            outline: var(--outline);
            outline-offset: 1px;
        }
    }

    :global(.eyebrow) {
        font: var(--font-eyebrow-14);
        margin-bottom: var(--spacer-24);
        letter-spacing: 0.1em;
        text-transform: uppercase;

        @media ($above-mobile) and ($below-tablet) {
            margin-bottom: var(--spacer-16);
        }
    }

    a:global(.buttonFilled) {
        @include filled-button-2026;

        margin-top: var(--spacer-16);
    }

    a:global(.secondaryButton) {
        @include secondary-button-2026;
    }

    img {
        display: inline;
    }
}

.constrainHalf {
    :where(p, li) {
        @media ($above-tablet) {
            max-width: 50vw;
        }
    }
}

.constrainTwoThirds {
    :where(p, li) {
        @media ($above-tablet) {
            max-width: 67vw;
        }
    }
}

.lengthyContent {
    visibility: inherit;
}

.conciseContent {
    @media ($above-mobile) {
        a:global(.buttonFilled):first-child {
            margin-top: var(--spacer-32);
        }
    }
}

.none {
    visibility: visible;
}

.firstChild {
    > *:first-child {
        margin-top: 0;
    }
}

.lastChild {
    > *:last-child {
        margin-bottom: 0;
    }
}

.both {
    composes: firstChild;
    composes: lastChild;
}

.layout {
    composes: gridContainer from "../../styles/composable/layout.module.css";

    > * {
        grid-column: span var(--grid-columns);
    }

    @media ($below-tablet) {
        align-self: end;

        --grid-columns: 12;
    }

    @media ($above-tablet) {
        &.left > * {
            grid-column: 1 / span 7;
        }

        &.center > * {
            grid-column: 3 / span 8;
        }

        &.right > * {
            grid-column: 6 / span 7;
        }
    }
}
